var e = {
	nav: { services: "Services" },
	list: {
		title: "Services",
		subtitle: "People and equipment guests can book by the session or by the day.",
		create: "Add a service",
		searchPlaceholder: "Search services",
		listingCount_one: "{{count}} option",
		listingCount_other: "{{count}} options",
		empty: {
			title: "No services yet",
			message: "A service is a provider — a photographer, a chef, a car. Add one, then price the lengths guests can book.",
			action: "Add your first service"
		},
		emptyFiltered: {
			title: "Nothing matches those filters",
			message: "No service matches what you searched for.",
			action: "Clear filters"
		},
		allStatuses: "All statuses",
		allKinds: "All kinds"
	},
	card: {
		startsFrom: "From",
		perBooking: "per booking",
		noPrice: "No options priced yet",
		nextSlot: "Next slot {{at}}",
		noSlots: "No slots scheduled",
		imageAlt: "Cover photo of {{title}}",
		noPhoto: "No cover photo"
	},
	detail: {
		capacity_one: "{{count}} booking at a time",
		capacity_other: "{{count}} bookings at a time",
		granularity: "Booked in {{minutes}}-minute blocks",
		granularityDays: "Booked by the day",
		serviceArea: "Travels up to {{km}} km",
		baseAddressOnly: "Works at the base address only",
		qualifications: "Qualifications",
		options: "Options",
		noOptions: "No options published yet — a guest cannot book until one exists.",
		nextSession: "Next slot",
		nextSessionNone: "None scheduled",
		seatsSoldThisMonth: "Bookings this month",
		viewSessions: "View slots",
		managePhotos: "Manage photos",
		quickActions: "Quick actions",
		editDetails: "Edit service",
		archive: "Archive service",
		archiveConfirmTitle: "Archive this service?",
		archiveConfirmBody: "Guests will no longer be able to find or book it. This can't be undone from here.",
		archived: "Service archived.",
		archiveFailed: "Couldn't archive this service.",
		about: "About this service",
		headerSummary: "{{category}} · {{grid}}",
		headerSummaryNoCategory: "{{grid}}",
		place: "Base address",
		schedule: "Working hours",
		scheduleWeekdays: "Available on {{days}}",
		scheduleHours: "{{day}}: {{hours}}",
		scheduleRangeDays: "Booked by the day, so there are no working hours to set.",
		scheduleNone: "No working hours yet — add them and we'll start opening slots.",
		bookingCutoff: "Bookings close {{minutes}} minutes before a slot starts.",
		bookingCutoffNone: "Guests can book right up to the start."
	},
	form: {
		titleInternal: "Internal name",
		titleInternalHint: "Only you see this. The name guests see belongs to each option.",
		schedulingKind: "How is it booked?",
		schedulingKindHint: "By session for an hourly provider; by day for something a guest keeps.",
		category: "Category",
		granularityMinutes: "Block length",
		granularityHint: "Every option's length has to be a whole number of these.",
		capacity: "How many at once?",
		capacityHint: "One chef is 1. Three cars is 3.",
		baseAddress: "Base address",
		serviceAreaKm: "How far will you travel?",
		serviceAreaHint: "Leave empty if you only work at the base address.",
		timezone: "Time zone",
		bookingCutoff: "Stop taking bookings",
		bookingCutoffHint: "How close to a start a guest can still book.",
		qualifications: "Qualifications",
		addQualification: "Add a qualification"
	},
	schedule: {
		title: "Working hours",
		subtitle: "We open bookable blocks from this pattern.",
		weekdays: "Working days",
		workingHours: "Hours",
		addRange: "Add hours",
		overlappingHours: "Two sets of hours on one day can't overlap.",
		rangeNoHours: "A service booked by the day has no working hours to set."
	},
	options: {
		durationMinutes: "Length",
		durationNotMultiple: "The length has to be a whole number of {{minutes}}-minute blocks.",
		durationNotWholeDays: "This service is booked by the day, so the length has to be whole days.",
		addOption: "Add option",
		created: "Option added.",
		createFailed: "Couldn't add this option."
	},
	errors: {
		featureUnavailable: "Services aren't available yet.",
		kindNotAvailable: "Add-ons attached to a stay aren't available yet. Choose by session or by day.",
		hasActiveListings_one: "{{count}} option is still bookable. Unpublish it before archiving this service.",
		hasActiveListings_other: "{{count}} options are still bookable. Unpublish them before archiving this service.",
		archived: "This service is archived."
	},
	wizard: {
		start: "Get started",
		finish: "Add service",
		back: "Back",
		next: "Next",
		kind: {
			title: "What kind of service is this?",
			addOnDisabled: "An add-on attached to a stay isn't available yet.",
			slotLabel: "By session",
			rangeLabel: "By day",
			addOnLabel: "Add-on to a stay"
		},
		photos: {
			title: "Add photos",
			hint: "Your first photo is the cover. A few more are needed before you can publish.",
			minimum: "A cover photo and at least {{count}} photos before you can publish.",
			addPhotos: "Add photos",
			cover: "Cover",
			makeCover: "Make cover",
			minRemaining_one: "{{count}} more photo to go",
			minRemaining_other: "{{count}} more photos to go",
			empty: "No photos yet.",
			rejected: "Some files were skipped — only images up to {{maxMb}} MB are accepted."
		},
		option: {
			title: "Price your first option",
			guestTitle: "Option name",
			guestTitleHint: "What guests see when they browse services — e.g. \"1-hour photo shoot\".",
			guestDescription: "Description",
			durationMinutes: "Length (minutes)",
			durationDays: "Length (days)",
			basePrice: "Price",
			currency: "Currency",
			privateGroupPrice: "Private group price",
			privateGroupPriceHint: "A flat price for the whole booking, instead of the per-booking rate. Leave empty to not offer it.",
			minGroupSize: "Minimum group size",
			maxGroupSize: "Maximum group size"
		},
		review: {
			title: "Review & publish",
			createFailed: "We couldn't add this service. Try again.",
			listingFailedTitle: "The service was created, but publishing its first option failed",
			listingFailedBody: "Your service is saved as a draft. Try publishing the option again below — nothing you entered was lost.",
			publishing: "Publishing…",
			photoCount_one: "{{count}} photo",
			photoCount_other: "{{count}} photos",
			editSection: "Edit",
			previewCaption: "What a guest sees",
			viewService: "View your service",
			retry: "Try again",
			publishNote: {
				title: "When you publish",
				live: "Your service goes live and guests can find it straight away.",
				blocks: "We open bookable blocks from your working hours and keep them topped up.",
				editable: "You can edit everything, add more options and add one-off blocks afterwards."
			}
		},
		place: {
			title: "Where does this service operate from?",
			enterManually: "Enter it manually",
			searchCta: "Search for the address",
			useCurrentLocation: "Use my current location",
			pinTitle: "Drop the exact pin",
			pinSubtitle: "Drag the map so the pin sits where it really is."
		},
		format: { title: "How it runs" },
		exitTitle: "Leave without saving?",
		exitBody: "Nothing is saved until you publish, so this service won't be here when you come back.",
		exitConfirm: "Discard",
		animations: {
			entryTitle: "Let's add your service",
			entrySubtitle: "A few questions about what you offer, where you work and when. You can change any of it afterwards.",
			photosTitle: "Now the photos",
			photosSubtitle: "Guests decide from the pictures. Lead with the one that shows the work you actually do.",
			completionTitle: "Your service is live",
			completionSubtitle: "Guests can find it and book you. Blocks open from your working hours from now on."
		},
		submitting: {
			settingUp: "Setting things up",
			creating: "Adding your service…",
			uploading: "Uploading your photos…",
			publishing: "Publishing your first option…",
			oops: "That didn't go through"
		}
	},
	sessions: {
		pageTitle: "Slots",
		pageSubtitle: "The slots generated from your working hours, plus any one-off you add.",
		addSession: "Add slot",
		addSessionOnDay: "Add a slot on {{date}}",
		bookedOfCapacity: "{{booked}}/{{capacity}} booked",
		aboutRemaining_one: "about {{count}} spot left",
		aboutRemaining_other: "about {{count}} spots left",
		full: "Full",
		editTitle: "Edit slot",
		addTitle: "Add a slot",
		alreadyCancelled: "This slot is cancelled.",
		dateLabel: "Date",
		timeLabel: "Start time",
		capacityLabel: "Capacity",
		timezoneNote: "Times are in {{zone}}.",
		cancelSession: "Cancel slot",
		saved: "Slot updated.",
		created: "Slot added.",
		cancelled: "Slot cancelled.",
		saveFailed: "Couldn't save this slot.",
		cancelFailed: "Couldn't cancel this slot.",
		slotHasSeats: "{{held}} held and {{booked}} booked — you can't cancel a slot guests are on. Cancel their bookings first, so they're told and refunded.",
		dayHeading: "Slots on {{date}}",
		dayEmpty: "No slots on this day.",
		pickADay: "Pick a day to see its slots.",
		timeRange: "{{start}} – {{end}}",
		cancelledLabel: "Cancelled",
		cancelConfirmTitle: "Cancel this slot?",
		cancelConfirmBody: "Guests can no longer book it. A slot that already has guests on it can't be cancelled here.",
		emptyMonthTitle: "No slots this month",
		emptyMonthBody: "Slots generated from your working hours appear here. You can also add a one-off.",
		noScheduleTitle: "No working hours yet",
		noScheduleBody: "Slots are generated from your working hours. Until they're set, you can still add one-off slots here."
	},
	photos: {
		empty: "No photos yet. Guests browse with their eyes — add a few before you publish.",
		rejected: "Those files couldn't be used — JPEG, PNG or WebP only, and under the size limit.",
		uploadFailed: "Couldn't add those photos. Try again.",
		deleteFailed: "Couldn't remove that photo. Try again."
	},
	guest: {
		providedBy: "{{category}} in {{area}}",
		providedAtBase: "Provided at the base",
		providedOnLocation: "Provided on location",
		options: "Options",
		optionDuration: "{{duration}}",
		messageToCustomise: "You can message {{host}} to customise or make changes.",
		qualifications: "My qualifications",
		thingsToKnow: "Things to know",
		cancellationPolicy: "Cancellation policy",
		whereProvided: "Where it happens",
		chooseOption: "Choose an option",
		chooseATime: "Choose a time",
		similar: "More services like this",
		suspended: "This service isn't taking new bookings right now.",
		notFound: {
			title: "This service isn't available",
			body: "It may have been removed, or it isn't published yet."
		}
	},
	edit: {
		detailsTitle: "Edit service",
		detailsSubtitle: "Everything here replaces what guests and the schedule read today.",
		photosTitle: "Edit photos",
		photosSubtitle: "A cover photo and at least {{count}} photos before you can publish.",
		saved: "Changes saved.",
		saveFailed: "Couldn't save your changes. Nothing was lost — try again.",
		photosNotUploaded_one: "{{count}} photo couldn't be uploaded",
		photosNotUploaded_other: "{{count}} photos couldn't be uploaded"
	}
};
//#endregion
export { e as default };
